import React, { Component } from 'react';
import {Switch} from "../buttons/Swtich";
import BudgetPartialGoalRows from "./BudgetPartialGoal";
import BudgetPartialGoalDailyRangeRows from "./BudgetPartialGoalDailyRange";
import {APIClient} from "../../utils/APIClient";
import {API_URL} from "../../settings/local_settings";
import {Spinner} from "../Spinner";
import {HELP_BUDGET_PARTIAL_GOALS, LinkToArticle} from "../help_center/LinkToArticle";
import { withTranslation } from 'react-i18next';
import {
    PARTIAL_GOALS_INPUT_MODE_CUMULATIVE,
    PARTIAL_GOALS_INPUT_MODE_DAILY_RANGE,
} from "../../utils/BudgetHelper";

export const ALLOCATED_AMOUNT_GOAL = "ALLOCATED_AMOUNT_GOAL";
export const PERCENTAGE_GOAL = "PERCENTAGE_GOAL";

class BudgetPartialGoalsConfigurationClass extends Component {
    constructor(props) {
        super(props);
        // Modo inicial: si vino un inputDefinition desde backend, arrancamos en DAILY_RANGE
        // (el backend solo persiste el JSON cuando el usuario configuró spike days/rangos).
        const hasInputDefinition = props.inputDefinition && props.inputDefinition.entries && props.inputDefinition.entries.length > 0;
        const initialMode = hasInputDefinition ? PARTIAL_GOALS_INPUT_MODE_DAILY_RANGE : PARTIAL_GOALS_INPUT_MODE_CUMULATIVE;
        this.state = {
            enabled: this.props.enabled,
            inputMode: initialMode,
            budgetPartialGoals: this.props.budgetPartialGoals,
            inputDefinition: this.props.inputDefinition || null,
            includedInAgencySubscription: null,
            pendingModeSwitch: null,
        };

        this.handleBudgetPartialGoalsChange = this.handleBudgetPartialGoalsChange.bind(this);
        this.handleDailyRangeEntriesChange = this.handleDailyRangeEntriesChange.bind(this);
        this.handleEnabledChange = this.handleEnabledChange.bind(this);
        this.handleModeChange = this.handleModeChange.bind(this);
    }

    componentDidMount() {
        this.fetchIncludedInAgencySubscription();
    }

    agencySubscriptionURL() {
        return API_URL + 'agency/subscription/';
    }

    fetchIncludedInAgencySubscription() {
        new APIClient(this.agencySubscriptionURL()).call('GET').then((data) => {
            if (data.status === 'ERROR_NO_AGENCY' || data.status === 'ERROR') {
                alert(data['error_message']);
            } else if (data.status === 'OK') {
                this.setState({
                    includedInAgencySubscription: data.data.budget_partial_goals_enabled
                });
            }
        })
    }

    handleBudgetPartialGoalsChange(budgetPartialGoals) {
        this.setState({...this.state, budgetPartialGoals: budgetPartialGoals}, ()=> { this.notifyParent(); });
    }

    handleDailyRangeEntriesChange(entries) {
        this.setState({...this.state, inputDefinition: { entries }}, () => { this.notifyParent(); });
    }

    notifyParent() {
        const payload = {
            inputMode: this.state.inputMode,
            budgetPartialGoals: this.state.budgetPartialGoals,
            inputDefinition: this.state.inputDefinition,
        };
        if (typeof this.props.onConfigurationChange === 'function') {
            this.props.onConfigurationChange(payload);
        } else if (typeof this.props.onChange === 'function') {
            // Compatibilidad: el contrato viejo solo recibía budgetPartialGoals.
            this.props.onChange(this.state.budgetPartialGoals);
        }
    }

    handleEnabledChange(event) {
        const enabled = event.target.checked;
        if (!enabled) {
            this.setState({
                budgetPartialGoals: [],
                inputDefinition: null,
                inputMode: PARTIAL_GOALS_INPUT_MODE_CUMULATIVE,
                enabled: false,
            }, () => { this.notifyParent(); });
        } else {
            this.setState({...this.state, enabled: true}, () => { this.notifyParent(); });
        }
    }

    handleModeChange(newMode) {
        if (newMode === this.state.inputMode) return;
        const hasCumulativeData = this.state.budgetPartialGoals && this.state.budgetPartialGoals.length > 0;
        const hasDailyRangeData = this.state.inputDefinition && this.state.inputDefinition.entries && this.state.inputDefinition.entries.length > 0;
        if ((this.state.inputMode === PARTIAL_GOALS_INPUT_MODE_CUMULATIVE && hasCumulativeData)
            || (this.state.inputMode === PARTIAL_GOALS_INPUT_MODE_DAILY_RANGE && hasDailyRangeData)) {
            this.setState({ pendingModeSwitch: newMode });
            return;
        }
        this._applyModeSwitch(newMode);
    }

    _applyModeSwitch(newMode) {
        this.setState({
            inputMode: newMode,
            budgetPartialGoals: [],
            inputDefinition: null,
            pendingModeSwitch: null,
        }, () => { this.notifyParent(); });
    }

    confirmModeSwitch = () => {
        this._applyModeSwitch(this.state.pendingModeSwitch);
    };

    cancelModeSwitch = () => {
        this.setState({ pendingModeSwitch: null });
    };

    renderModeSwitchModal() {
        if (!this.state.pendingModeSwitch) return null;
        const { t } = this.props;
        return (
            <div className="daily-range-mode-modal" style={{
                position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
                backgroundColor: 'rgba(0,0,0,0.4)', zIndex: 1050,
                display: 'flex', alignItems: 'center', justifyContent: 'center',
            }}>
                <div style={{ backgroundColor: 'white', borderRadius: '0.3em', maxWidth: '420px', padding: '1.5em' }}>
                    <h5>{t('budget_partial_goals_config.switch_mode_modal.title')}</h5>
                    <p style={{ marginTop: '0.5em' }}>{t('budget_partial_goals_config.switch_mode_modal.body')}</p>
                    <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '0.5em', marginTop: '1em' }}>
                        <button type="button" className="btn -negative" onClick={this.cancelModeSwitch}>
                            {t('budget_partial_goals_config.switch_mode_modal.cancel')}
                        </button>
                        <button type="button" className="btn" onClick={this.confirmModeSwitch}>
                            {t('budget_partial_goals_config.switch_mode_modal.confirm')}
                        </button>
                    </div>
                </div>
            </div>
        );
    }

    renderModeToggle() {
        if (!this.props.allowDailyRangeMode) return null;
        const { t } = this.props;
        const isCumulative = this.state.inputMode === PARTIAL_GOALS_INPUT_MODE_CUMULATIVE;
        const segmentBase = {
            border: 'none',
            background: 'transparent',
            padding: '0.35em 0.9em',
            borderRadius: '0.25em',
            fontSize: '0.85em',
            cursor: 'pointer',
            transition: 'background-color 120ms ease, color 120ms ease, box-shadow 120ms ease',
            color: '#4A4A4A',
            fontWeight: 500,
            lineHeight: 1.4,
        };
        const segmentActive = {
            background: '#FFFFFF',
            color: '#FF470F',
            fontWeight: 600,
            boxShadow: '0 1px 2px rgba(0,0,0,0.08), 0 0 0 1px rgba(0,0,0,0.04)',
        };
        return (
            <div className="daily-range-mode-toggle" style={{ marginBottom: '0.85em', display: 'flex', gap: '0.6em', alignItems: 'center' }}>
                <span style={{ fontSize: '0.85em', color: '#4A4A4A', letterSpacing: '0.01em' }}>
                    {t('budget_partial_goals_config.input_mode.label')}
                </span>
                <div role="tablist" aria-label={t('budget_partial_goals_config.input_mode.label')}
                     style={{
                         display: 'inline-flex',
                         background: '#F5F5F5',
                         border: '1px solid #ECECEC',
                         borderRadius: '0.3em',
                         padding: '0.15em',
                         gap: '0.15em',
                     }}>
                    <button type="button"
                            role="tab"
                            aria-selected={isCumulative}
                            style={{ ...segmentBase, ...(isCumulative ? segmentActive : {}) }}
                            onClick={() => this.handleModeChange(PARTIAL_GOALS_INPUT_MODE_CUMULATIVE)}>
                        {t('budget_partial_goals_config.input_mode.cumulative')}
                    </button>
                    <button type="button"
                            role="tab"
                            aria-selected={!isCumulative}
                            style={{ ...segmentBase, ...(!isCumulative ? segmentActive : {}) }}
                            onClick={() => this.handleModeChange(PARTIAL_GOALS_INPUT_MODE_DAILY_RANGE)}>
                        {t('budget_partial_goals_config.input_mode.daily_range')}
                    </button>
                </div>
            </div>
        );
    }

    renderPartialRows() {
        if (!this.state.enabled)
            return null;

        if (this.state.includedInAgencySubscription === null)
            return <div className="box-loader"><Spinner color="positive"/></div>;

        if (!this.state.includedInAgencySubscription)
            return this.renderNoInSubscriptionMessage();

        if (this.state.inputMode === PARTIAL_GOALS_INPUT_MODE_DAILY_RANGE) {
            return (
                <div>
                    {this.renderModeToggle()}
                    <BudgetPartialGoalDailyRangeRows
                        budgetTotalAmount={this.props.budgetTotalAmount}
                        budgetPeriodType={this.props.budgetPeriodType}
                        budgetFromDate={this.props.budgetFromDate}
                        budgetToDate={this.props.budgetToDate}
                        inputDefinition={this.state.inputDefinition}
                        onChange={this.handleDailyRangeEntriesChange}
                        numberLocale={this.props.numberLocale}
                        dateLocale={this.props.dateLocale}
                    />
                </div>
            );
        }

        return (
            <div className="row g-3">
                {this.renderModeToggle()}
                <BudgetPartialGoalRows
                    budgetTotalAmount={this.props.budgetTotalAmount}
                    budgetPeriodType={this.props.budgetPeriodType}
                    budgetFromDate={this.props.budgetFromDate}
                    budgetToDate={this.props.budgetToDate}
                    budgetPartialGoals={this.state.budgetPartialGoals}
                    onChange={this.handleBudgetPartialGoalsChange}
                    numberLocale={this.props.numberLocale}
                    dateLocale={this.props.dateLocale}
                />
            </div>
        );
    }

    renderNoInSubscriptionMessage() {
        const { t } = this.props;
        return <div className="alert alert-info" style={{margin:"0.6em 1.5em 0.6em 2.6em"}}>
                {t('budget_partial_goals_config.subscription_message')}
        </div>;
    }

    /**
     * `compact`: la variante para el drawer de la línea (UX 2.1), donde el label ya ocupa dos
     * renglones. Ahí el link va sin corchetes —el lenguaje de la 2.1— y con un texto más corto,
     * que es lo que le permite quedar en la misma línea. Sin la prop, el link es el de siempre.
     */
    renderHelpLink() {
        const { t } = this.props;
        if (this.props.compact !== true) {
            return <LinkToArticle article={HELP_BUDGET_PARTIAL_GOALS}/>;
        }
        return <LinkToArticle article={HELP_BUDGET_PARTIAL_GOALS}
                              plain={true}
                              text={t('budget_partial_goals_config.help_link', 'Cómo funciona')}/>;
    }

    render() {
        const { t } = this.props;
        return (
            <div style={{ marginTop: '20px' }}>
                <div className="form-row switch-input -horizontal" style={{ borderBottom: "0", marginBottom: "0", position: "relative", zIndex: 2, justifyContent: 'flex-start', padding: 0 }}>
                    <Switch style={{marginLeft: "0"}} onChange={this.handleEnabledChange} checked={this.state.enabled} name="enabled"/>
                    <label style={{paddingLeft:"10px", position: "relative", backgroundColor: "white", padding: "0 0px", marginLeft: "10px"}}>
                        {t('budget_partial_goals_config.want_define_investment_segments')} {this.renderHelpLink()}
                    </label>
                </div>
                {this.state.enabled && (
                    <div className="radio-box-border">
                        {this.renderPartialRows()}
                    </div>
                )}
                {this.renderModeSwitchModal()}
            </div>
        );
    }
}

export const BudgetPartialGoalsConfiguration = withTranslation()(BudgetPartialGoalsConfigurationClass);
export default BudgetPartialGoalsConfiguration;
